<script setup lang="ts">
import { computed } from 'vue'
import type { IInputFieldEvents, IInputFieldProps } from '../types'
import { PInput, PLabel } from '../parts'
import useInputLogic from '@/ui/plushComponents/VInputField/composables/useInputLogic'

const props = defineProps<IInputFieldProps<'phone'>>()
const emit = defineEmits<IInputFieldEvents>()

const options = computed(() => props.options)

const PHONE_MAX_LENGTH = 9

const { isError, valueLength, debouncedUpdateModelValue, handleClear, handleBlur, handleFocus } = useInputLogic(
    props,
    emit,
)
</script>

<template>
    <div class="grow-1 flex max-w-[480px] flex-col">
        <PLabel
            v-bind="options"
            :label="options.label || 'Numer telefonu'"
            :model-value-length="valueLength"
            :max-length="PHONE_MAX_LENGTH"
        />
        <PInput
            v-bind="options"
            :model-value="props.modelValue"
            :aria="{
                label: options.label || 'Numer telefonu',
            }"
            type="tel"
            input-mode="tel"
            prefix="+48"
            :max-length="PHONE_MAX_LENGTH"
            mask="999 999 999"
            placeholder=""
            :leading-icon="false"
            :trailing-icon="false"
            :is-error="isError"
            :auto-complete="options.autoComplete ?? 'autocomplete'"
            :auto-focus="options.autoFocus ?? false"
            :data-test="props.dataTest"
            @update:model-value="debouncedUpdateModelValue"
            @clear="handleClear"
            @blur="handleBlur"
            @focus="handleFocus"
        />
        <ValidationMessage
            v-if="isError"
            status="error"
            :text="options.errorMessage || 'UPS! Wprowadzono złe dane!'"
            class="mt-2xs !p-0"
            size="SMALL"
            data-test="default-input-test"
        />
        <HelperMessage
            v-if="options.helper"
            class="mt-2xs"
            size="SMALL"
            :message="options.helper"
        />
    </div>
</template>
